"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareSvg = prepareSvg;
exports.push = push;
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable func-names */
var isBrowser = typeof window !== 'undefined';
var svgId = "foxui-biz-icon";
var svg = isBrowser ? window.document.getElementById(svgId) : undefined;
var svgTemplate = "";
var timer = null;
function push(id, symbolElementString) {
  if (!isBrowser) return;
  if (document.getElementById(id)) return;
  svgTemplate += symbolElementString;
  if (!svg) return;
  // 合并更新
  function update() {
    if (svg) {
      svg.insertAdjacentHTML('beforeend', svgTemplate);
      svgTemplate = '';
    }
  }
  if (timer !== null) clearTimeout(timer);
  timer = setTimeout(function () {
    update();
  }, 0);
}
var prepared = false;
function prepareSvg() {
  if (!isBrowser) return;
  var script = function () {
    var scripts = document.getElementsByTagName('script');
    return scripts[scripts.length - 1];
  }();
  var shouldInjectCss = script.getAttribute('data-injectcss');
  var ready = function ready(fn) {
    if (document.addEventListener) {
      if (['complete', 'loaded', 'interactive'].indexOf(document.readyState) > -1) {
        setTimeout(fn, 0);
      } else {
        var _loadFn = function loadFn() {
          document.removeEventListener('DOMContentLoaded', _loadFn, false);
          fn();
        };
        document.addEventListener('DOMContentLoaded', _loadFn, false);
      }
    } else if (document.attachEvent) {
      IEContentLoaded(window, fn);
    }
    function IEContentLoaded(w, fn) {
      var d = w.document;
      var done = false;
      var init = function init() {
        if (!done) {
          done = true;
          fn();
        }
      };
      var _polling = function polling() {
        try {
          d.documentElement.doScroll('left');
        } catch (e) {
          setTimeout(_polling, 50);
          return;
        }
        init();
      };
      _polling();
      d.onreadystatechange = function () {
        if (d.readyState === 'complete') {
          d.onreadystatechange = null;
          init();
        }
      };
    }
  };
  var before = function before(el, target) {
    target.parentNode.insertBefore(el, target);
  };
  var prepend = function prepend(el, target) {
    if (target.firstChild) {
      before(el, target.firstChild);
    } else {
      target.appendChild(el);
    }
  };
  function appendSvg() {
    var svgSprite = "<svg>".concat(svgTemplate, "</svg>");
    var div = document.createElement('div');
    div.innerHTML = svgSprite;
    svgSprite = null;
    // eslint-disable-next-line prefer-destructuring
    svg = div.getElementsByTagName('svg')[0];
    if (svg) {
      // svg.id = svgId;
      svg.setAttribute('aria-hidden', 'true');
      svg.style.position = 'absolute';
      svg.style.width = '0px';
      svg.style.height = '0px';
      svg.style.overflow = 'hidden';
      prepend(svg, document.body);
      // clear queue;
      svgTemplate = '';
    }
  }
  if (shouldInjectCss && !window.__iconfont__svg__cssinject__) {
    window.__iconfont__svg__cssinject__ = true;
    try {
      document.write('<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>');
    } catch (e) {
      console && console.log(e);
    }
  }
  if (!prepared) {
    prepared = true;
    ready(appendSvg);
  }
}